import {
    CardScales,
    resolveRoomLayout,
} from "./RoomLayout";

export type { CardScales } from "./RoomLayout";

export function calculateCardScales(width: number, height: number): CardScales {
    return resolveRoomLayout(width, height).scales;
}

export function getScales(): CardScales {
    return calculateCardScales(window.innerWidth, window.innerHeight);
}
